import React from 'react';
import { Hr } from 'ggApp/shared/screens/PartnerProductPage/Common';
import AboutGrover from './components/AboutGrover';
import WhyRent from './components/WhyRent';
import HowItWorks from './components/HowItWorks';
import Faq from './components/Faq';

export const Content = ({ content }) => {
    const aboutGroverContent = content?.groverDescription;
    const whyRentContent = content?.whyRentBlock;
    const howItWorksContent = content?.howItWorksBlock;
    const faqContent = content?.faqsList;
    const faqTitle = content?.faqBlockTitle;
    return (
        <>
            {aboutGroverContent && (
                <>
                    <Hr />
                    <AboutGrover content={aboutGroverContent} />
                    <Hr />
                </>
            )}
            {whyRentContent && (
                <>
                    <WhyRent content={whyRentContent} />
                    <Hr />
                </>
            )}
            {howItWorksContent && (
                <>
                    <HowItWorks content={howItWorksContent} />
                    <Hr />
                </>
            )}
            {faqTitle && faqContent && <Faq title={faqTitle} content={faqContent} />}
        </>
    );
};
